import { createFileRoute } from '@tanstack/react-router'
import { ViewPetPage } from '_/features/pets/ui/pages/view-pet-page'

const ViewPetRoute = () => {
	const { petId } = Route.useParams()
	return <ViewPetPage petId={petId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/')({
	staticData: { title: 'pets_details' },
	component: ViewPetRoute,
})
